import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLFollowUpReportAdditionalFilter.metadata.json5';
import './MLFollowUpReportAdditionalFilter.messages';

const MLFollowUpReportAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData,
        assignedByValues,
        prioritiesTypelist
    } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const [prioritiesAvaiVal, updatePrioritiesAvaiVal] = useState([]);
    const [assignedByAvaiVal, updateAssignedByAvaiVal] = useState([]);

    useEffect(() => {
        const prioritiesAvailableValues = prioritiesTypelist.codes.map((priority) => {
            return {
                code: priority.code,
                name: translator({
                    id: priority.name,
                    defaultMessage: priority.name
                })
            };
        });
        updatePrioritiesAvaiVal(prioritiesAvailableValues);

        const assignedByAvailableValues = assignedByValues.map((assignedBy) => {
            return {
                code: assignedBy,
                name: assignedBy
            };
        });
        updateAssignedByAvaiVal(assignedByAvailableValues);
    }, [assignedByValues, prioritiesTypelist.codes, translator]);

    const onValueChange = (value, path) => {
        _.set(filterData, path, value);
        updateFilterData(filterData);
        refreshData();
    }

    const overrideProps = {
        assignedBy: {
            availableValues: assignedByAvaiVal,
            value: _.get(filterData, 'assignedByUser_ML')
        },
        priorities: {
            availableValues: prioritiesAvaiVal,
            value: _.get(filterData, 'priority_ML')
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
            onValueChange={onValueChange}
        />
    );
};

MLFollowUpReportAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired,
    assignedByValues: PropTypes.array.isRequired,
    prioritiesTypelist: PropTypes.array.isRequired
};

export default MLFollowUpReportAdditionalFilter;
